const groups: Record<string, string> = {}

const isBrowser = (): boolean => typeof window !== 'undefined'

export const setExperimentGroup = (experimentName: string, group: string): void => {
    if (!isBrowser()) {
        return
    }

    groups[experimentName] = group
}

export const getExperimentGroups = (): Record<string, string> => {
    if (!isBrowser()) {
        return {}
    }

    return {...groups}
}
